// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import { graphql, Link } from 'gatsby';
import { Row, Col } from 'react-bootstrap';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import {
  Stitle,
  SPageContainer,
  SPageTitleLink,
  SPageList,
  SH1,
} from './styles';
import useWpPagesData from '../../pageDataHooks/useWpPagesData';

const AllContentPage = () => {
  const { contentfulPage: data, allWpPage } = useWpPagesData();

  const allWpPageNodes = allWpPage.nodes;

  const makePageCards = nodes => {
    return nodes
      .filter(
        pageData => pageData.title === 'Tenant Guide to Renting A Property',
      )
      .map(pageData => {
        return (
          <Row key={pageData.title} className="justify-content-between">
            <Col sm={12} className="blog__list--type">
              <SPageTitleLink>
                <Link to={`/pages/${pageData.slug}`}>
                  <Stitle>{pageData.title}</Stitle>
                </Link>
              </SPageTitleLink>
            </Col>
          </Row>
        );
      })
      .splice(0, 3);
  };

  return (
    <Layout logoType={'light'}>
      <SEO
        description={data.metaDescription.metaDescription}
        title={data.metaTitle}
      />

      <SPageContainer className="my-5">
        <SH1>Content Pages</SH1>

        <SPageList>{makePageCards(allWpPageNodes)}</SPageList>
      </SPageContainer>
    </Layout>
  );
};

AllContentPage.propTypes = {
  data: PropTypes.object,
};

export default AllContentPage;
